import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img
              src="https://customer-assets.emergentagent.com/job_condodigitalchile/artifacts/ddn74r4e_Logo%20Tu%20Condominio%20Digital%20%281%29.png"
              alt="Tu Condominio Digital"
              className="h-12 w-12 object-contain"
            />
            <span className={`font-bold text-xl transition-colors ${
              isScrolled ? 'text-[#082E5C]' : 'text-white'
            }`}>
              Tu Condominio Digital
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('servicios')}
              className={`text-sm font-medium transition-colors hover:text-[#00D4D8] ${
                isScrolled ? 'text-[#082E5C]' : 'text-white'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('tecnologia')}
              className={`text-sm font-medium transition-colors hover:text-[#00D4D8] ${
                isScrolled ? 'text-[#082E5C]' : 'text-white'
              }`}
            >
              Tecnología
            </button>
            <button
              onClick={() => scrollToSection('perfiles')}
              className={`text-sm font-medium transition-colors hover:text-[#00D4D8] ${
                isScrolled ? 'text-[#082E5C]' : 'text-white'
              }`}
            >
              Para Ti
            </button>
            <button
              onClick={() => scrollToSection('nosotros')}
              className={`text-sm font-medium transition-colors hover:text-[#00D4D8] ${
                isScrolled ? 'text-[#082E5C]' : 'text-white'
              }`}
            >
              Nosotros
            </button>
            <Button
              onClick={() => scrollToSection('contacto')}
              className="bg-[#00D4D8] hover:bg-[#00B8BC] text-white transition-all duration-300 hover:scale-105"
            >
              Contáctanos
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-[#082E5C]' : 'text-white'} size={24} />
            ) : (
              <Menu className={isScrolled ? 'text-[#082E5C]' : 'text-white'} size={24} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => scrollToSection('servicios')}
                className="text-[#082E5C] hover:text-[#00D4D8] text-left px-4 py-2"
              >
                Servicios
              </button>
              <button
                onClick={() => scrollToSection('tecnologia')}
                className="text-[#082E5C] hover:text-[#00D4D8] text-left px-4 py-2"
              >
                Tecnología
              </button>
              <button
                onClick={() => scrollToSection('perfiles')}
                className="text-[#082E5C] hover:text-[#00D4D8] text-left px-4 py-2"
              >
                Para Ti
              </button>
              <button
                onClick={() => scrollToSection('nosotros')}
                className="text-[#082E5C] hover:text-[#00D4D8] text-left px-4 py-2"
              >
                Nosotros
              </button>
              <Button
                onClick={() => scrollToSection('contacto')}
                className="bg-[#00D4D8] hover:bg-[#00B8BC] text-white mx-4"
              >
                Contáctanos
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
